import { useContext, useCallback } from 'react';

import { ColorContext } from './ColorContext';

export const useColor = () => {
  const ctx = useContext(ColorContext);

  if (!ctx) {
    throw new Error('useColor deve ser usado dentro de um ColorProvider');
  }

  const getHexByNome = useCallback(
    (nomeCor?: string, fallback = '#000000') => {
      if (!nomeCor) return fallback;

      const cor = ctx.coresSelect.find(
        (c) => c.nomeCor.toLowerCase() === nomeCor.toLowerCase(),
      );

      return cor?.codigoHexadecimal ?? fallback;
    },
    [ctx.coresSelect],
  );

  return {
    ...ctx,
    getHexByNome,
  };
};
